import { useQuery } from "@tanstack/react-query";
import { budgetApi } from "../api/budgets";
import { invoiceApi } from "../api/invoices";
import { requireData } from "./http";

export const useProjectBudget = (projectId: number | null) =>
  useQuery({
    queryKey: ["client-budget", projectId],
    queryFn: async () => {
      const [summary, invoices] = await Promise.all([
        budgetApi.getForProject(projectId!).then(requireData),
        invoiceApi.forProject(projectId!).then(requireData),
      ]);
      return { summary, invoices: invoices.invoices };
    },
    enabled: projectId !== null,
    refetchInterval: 30_000,
  });
